module.exports = __webpack_public_path__ + "img/2.5ea80af6.png";